import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import { GoogleOAuthProvider } from '@react-oauth/google';
import { OnymosAccessProvider } from '@onymos/react-access';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <GoogleOAuthProvider clientId='1098911982655-4il75iaeqph13ghl70ugebt76h12np7k.apps.googleusercontent.com'>
  <OnymosAccessProvider googleClientId='1098911982655-4il75iaeqph13ghl70ugebt76h12np7k.apps.googleusercontent.com'>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </OnymosAccessProvider>
  // </GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
